import { render } from "./Solutions.vue?vue&type=template&id=068ec766&scoped=true&ts=true"
import script from "./Solutions.vue?vue&type=script&lang=ts"
export * from "./Solutions.vue?vue&type=script&lang=ts"

import "./Solutions.vue?vue&type=style&index=0&id=068ec766&scoped=true&lang=scss"
import "./Solutions.vue?vue&type=style&index=1&id=068ec766&scoped=true&lang=scss"
import "./Solutions.vue?vue&type=style&index=2&id=068ec766&scoped=true&lang=scss"
import "./Solutions.vue?vue&type=style&index=3&id=068ec766&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068ec766"]])

export default __exports__